import { render, staticRenderFns } from "./NewVideoCategoryPage.vue?vue&type=template&id=14b4e856&"
import script from "./NewVideoCategoryPage.vue?vue&type=script&lang=js&"
export * from "./NewVideoCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports